import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Pagination = ({ currentPage, totalItems, pageSize = 10, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  if (totalPages <= 1) return null;

  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalItems);

  return (
    <div className="flex items-center justify-between pt-5 border-t border-slate-100 dark:border-slate-700 mt-5" data-testid="pagination">
      <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">
        Showing <span className="text-slate-700 dark:text-slate-200">{start}–{end}</span> of <span className="text-slate-700 dark:text-slate-200">{totalItems}</span>
      </p>
      <div className="flex items-center gap-1.5">
        <Button
          variant="outline"
          size="sm"
          className="h-8 w-8 p-0 rounded-lg border-slate-200 hover:bg-slate-50 hover:border-slate-300 transition-all"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
          data-testid="pagination-prev"
        >
          <ChevronLeft className="w-4 h-4" />
        </Button>
        {Array.from({ length: totalPages }, (_, i) => i + 1)
          .filter(p => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1)
          .reduce((acc, p, idx, arr) => {
            if (idx > 0 && p - arr[idx - 1] > 1) {
              acc.push("...");
            }
            acc.push(p);
            return acc;
          }, [])
          .map((p, i) =>
            p === "..." ? (
              <span key={`dots-${i}`} className="text-xs text-slate-400 px-1">...</span>
            ) : (
              <Button
                key={p}
                variant={p === currentPage ? "default" : "outline"}
                size="sm"
                className={`h-8 w-8 p-0 text-xs font-semibold rounded-lg transition-all ${
                  p === currentPage 
                    ? "bg-gradient-to-br from-slate-900 to-slate-800 text-white shadow-md border-0" 
                    : "border-slate-200 hover:bg-slate-50 hover:border-slate-300"
                }`}
                onClick={() => onPageChange(p)}
                data-testid={`pagination-page-${p}`}
              >
                {p}
              </Button>
            )
          )}
        <Button
          variant="outline"
          size="sm"
          className="h-8 w-8 p-0 rounded-lg border-slate-200 hover:bg-slate-50 hover:border-slate-300 transition-all"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          data-testid="pagination-next"
        >
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};
